global.LinkTo = function(element) {
  element.click(function(e) {
    var target = $( e.target );
    if(!target.is("a")) {
      var location = element.data('location');
      window.location = location;
    }
  });
};
